import React from 'react';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import { useEditorTheme } from './redux/editor/EditorHooks';

export const AppWithTheme = () => {
  const themeInUse = useEditorTheme();
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themeInUse}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
